<template>
    <v-card flat>
        <v-card-title class="subheader py-0">
            <v-icon small class="mr-1" color="blue">money</v-icon>
            经费预算
            <v-spacer/>
            <v-btn flat round color="primary" dark
                   :disabled="!funcIds.includes('c_proj_inco')"
                   @click.native.stop="
                     () => {
                          editDbid = null;
                          projTypeId = project.typeId;
                          projectId = project.dbid;
                          edit = true;
                        }">
                <v-icon>add</v-icon>
                新建预算
            </v-btn>
        </v-card-title>
        <v-divider color="orange"/>

        <v-card-text class="pt-0">
            <v-data-table
                    :headers="headers"
                    :items="items"
                    hide-actions
                    class="elevation-0 dense"
                    no-data-text="没有数据。">
                <template slot="items" slot-scope="props">
                    <td>{{ props.index + 1}}</td>
                    <td class="">{{ props.item.tplName }}</td>
                    <td class="">{{ props.item.amount | currency}}</td>
                    <td class="justify-center layout px-0">
                        <v-tooltip top>
                            <v-btn icon class="mx-0" slot="activator"
                                   @click="() => {
                                        viewDbid = props.item.dbid; view = true;
                                     }">
                                <v-icon color="teal">more_horiz</v-icon>
                            </v-btn>
                            <span>查看</span>
                        </v-tooltip>

                        <v-tooltip top>
                            <v-btn
                                    icon class="mx-0" slot="activator"
                                    :disabled="!funcIds.includes('u_proj_inco')"
                                    @click="
                                         () => {
                                            editDbid = props.item.dbid;
                                            projTypeId = project.typeId;
                                            editDefault = {};
                                            edit = true;
                                         }">
                                <v-icon color="teal">edit</v-icon>
                            </v-btn>
                            <span>编辑</span>
                        </v-tooltip>

                        <v-tooltip top>
                            <v-btn
                                    icon class="mx-0" slot="activator"
                                    :disabled="!funcIds.includes('d_proj_inco')"
                                    @click="
                                         () => {
                                            deleDbid = props.item.dbid;
                                            deleMsg = `${Math.round(props.item.amount*100)/100}万元 / ${props.item.tplName}`;
                                            dele = true;
                                         }">
                                <v-icon color="pink">delete_forever</v-icon>
                            </v-btn>
                            <span>删除</span>
                        </v-tooltip>
                    </td>
                </template>
            </v-data-table>
        </v-card-text>

        <x-view v-model="view"
                :project-id="project.dbid"
                :dbid="viewDbid"/>

        <x-edit v-model="edit"
                :dbid="editDbid"
                :proj-type-id="projTypeId"
                :project-id="project.dbid"
                v-on:ok="onEditOk"/>

        <x-delete v-model="dele"
                  :message="deleMsg"
                  :uri="uri"
                  :dbid="deleDbid"
                  v-on:ok="onDeleOk"/>

    </v-card>
</template>
<script>
    import {mapGetters} from 'vuex'

    import XEdit from './Edit'
    import XView from './View'

    import XDelete from '@/components/global/Delete'

    const baseURI = '/api/proj/budget-item';

    export default {
        components: {XEdit, XDelete, XView},

        props: {
            project: Object
        },

        data: () => ({
            uri: baseURI,
            headers: [
                {text: '#', sortable: false, value: 'dbid', width: '20'},
                {text: '预算名称', value: 'tplName', sortable: false},
                {text: '金额(元)', value: 'amount', sortable: false},
                {text: '操作', value: 'dbid', sortable: false, align: 'right', width: 90},
            ],

            items: [],

            view: false,
            viewDbid: null,

            edit: false,
            editDbid: null,
            projTypeId: null,
            projectId: null,
            editDefault: {},

            dele: false,
            deleDbid: null,
            deleMsg: null,
        }),

        computed: {
            ...mapGetters(['funcIds'])
        },

        watch: {
            project(p) {
                this.printProj = window.xutil.clone(p);
                this.axios
                    .get(`${baseURI}?projectId=${p.dbid}`)
                    .then(rsp => this.items = rsp.data.items)
            }
        },

        methods: {
            getDefault() {
                return {
                    projectId: this.project.dbid,
                }
            },
            onEditOk(items) {
                let item = items[0];
                // window.console.log("in Income onEditOK");
                if (item) {
                    if (!this.editDbid) {
                        this.items.unshift(item);
                    } else {
                        const editIdx = this.items.findIndex(v => v.dbid === item.dbid);
                        let its = window.xutil.clone(this.items);
                        its[editIdx] = Object.assign({}, item);
                        this.items = its;
                    }
                }
            },
            onDeleOk(item) {
                if (item) {
                    const deleIdx = this.items.findIndex(v => v.dbid === item.dbid);
                    this.items.splice(deleIdx, 1);
                }
            },
        }
    }
</script>
